import {useEffect, useState} from "react";
import {
    collection,
    endAt,
    getCountFromServer,
    getDocs,
    limit,
    orderBy,
    query,
    startAfter,
    where
} from "firebase/firestore";
import {fire} from "../../fire";

export const useObtenerColleccionTabla2025 = ({
                                              coleccion,
                                              filtroInicial = 'fecha',
                                              dirInicial = 'desc',
                                              adaptador = null,
                                              nombreEstado = 'estado'
                                          }) => {
    const [numeroFilas, setNumeroFilas] = useState(0)
    const [itemFinal, setItemFinal] = useState('Todo')
    const [page, setPage] = useState(0);
    const [data, setData] = useState([])
    const [filasPagina, setFilasPagina] = useState(10);
    const [filtroEscogido, setFiltroEscogido] = useState({propiedad: filtroInicial, direccion: dirInicial})
    const [estado, setEstado] = useState('')
    const [cargar, setCargar] = useState(false)
    const [cargando, setCargando] = useState(false)


    const cargarNuevamente = () => {
        setCargar(!cargar)
    }

    const filasPaginaCambia = (event) => {

        let filas = parseInt(event.target.value)
        setFilasPagina(filas);

        setPage(0);

        const coll = collection(fire, coleccion);

        // seteamos where si hay un estado elegido
        let wheres = []
        if (estado !== 'Todo' && estado !== '') {
            wheres.push(where(nombreEstado, '==', estado))
        } else {
            wheres = []
        }

        const q = query(coll, ...wheres, limit(filas), orderBy(filtroEscogido.propiedad, filtroEscogido.direccion))

        getDocs(q).then((dox) => {
            let array = []
            for (let i = 0; i < dox.docs.length; i++) {
                let obj = dox.docs[i].data()
                if (i === dox.docs.length - 1) {
                    setItemFinal(obj)
                }
                if (adaptador !== null) {
                    obj = adaptador(obj)
                }
                array.push(obj)

            }


            setData(array)

        })


    };

    const cambiarPagina = (event, nuevaPagina) => {

        const coll = collection(fire, coleccion);
        const getDireccionPagina = () => {
            if (page < nuevaPagina) {
                return startAfter(itemFinal[filtroEscogido.propiedad])
            } else {
                return endAt(itemFinal[filtroEscogido.propiedad])
            }
        }

        // seteamos where si hay un estado elegido
        let wheres = []
        if (estado !== 'Todo' && estado !== '') {
            wheres.push(where(nombreEstado, '==', estado))
        } else {
            wheres = []
        }


        const q = query(coll, ...wheres, limit(filasPagina), orderBy(filtroEscogido.propiedad, filtroEscogido.direccion), getDireccionPagina())

        setPage(nuevaPagina);
        getDocs(q).then((dox) => {
            let array = []
            for (let i = 0; i < dox.docs.length; i++) {
                let obj = dox.docs[i].data()
                if (i === dox.docs.length - 1) {
                    setItemFinal(obj)
                }

                if (adaptador !== null) {
                    obj = adaptador(obj)
                }
                array.push(obj)

            }


            setData(array)

        })

    };


    const props = {
        data,
        cambiarPagina,
        numeroFilas,
        page,
        setPage,
        filasPagina,
        setFilasPagina,
        filtroEscogido,
        setFiltroEscogido,
        filasPaginaCambia,
        estado,
        setEstado,
        nombreEstado,
        cargando,
    }


    useEffect(() => {
        setData([])
        setPage(0)
        setCargando(true)
        // numero total de filas
        const coll = collection(fire, coleccion);

        // seteamos where si hay un estado elegido
        let wheres = []
        if (estado !== 'Todo' && estado !== '') {
            wheres.push(where(nombreEstado, '==', estado))
        } else {
            wheres = []
        }


        const q = query(coll, ...wheres, limit(filasPagina), orderBy(filtroEscogido.propiedad, filtroEscogido.direccion))

        const qCon = query(coll, ...wheres)
        // contamos cuantos documento hay
        getCountFromServer(qCon).then((dox) => {
            setNumeroFilas(dox.data().count)
        })


        getDocs(q).then((dox) => {
            let array = []
            for (let i = 0; i < dox.docs.length; i++) {
                let obj = dox.docs[i].data()
                if (i === dox.docs.length - 1) {
                    setItemFinal(obj)
                }
                if (adaptador !== null) {
                    obj = adaptador(obj)
                }

                array.push(obj)

            }
            setCargando(false)

            setData(array)

        })
    }, [filtroEscogido, estado, cargar]);


    useEffect(() => {

        let col = collection(fire, coleccion)
        const q = query(col);
        getCountFromServer(q).then((dox) => {
            setNumeroFilas(dox.data().count)
        }).catch((err) => {
            setNumeroFilas(0)
        })

    }, [coleccion]);
    return {
        props,
        cargarNuevamente,
        setData,
        setNumeroFilas,
        numeroFilas
    }
}